import React from 'react'
import Banner from '@components/Banner'
import { ProfileCard } from '@components/Card'

const ProfessionalHeader = ({
  parentPath,
  professional,
  professional: { links },
  tabsArr,
  previousQuery,
  previousRefinements,
}) => {
  return (
    <Banner
      wideStacked
      breadcrumbs
      crumbLabel="All Professionals"
      crumbClassName="qtph-profprofile-allprof-link"
      to={parentPath}
      maxWidth={1200}
      gradient="blue-gold"
      previousQuery={previousQuery}
      previousRefinements={previousRefinements}
    >
      <ProfileCard
        person={professional}
        id={professional.id}
        socialProfiles={links}
        xl
        pdfFileName={professional.name}
        offices={professional.offices}
      />
    </Banner>
  )
}
export default ProfessionalHeader
